/**
 * Plugin for Referral Token Handling
 * Автоматически обрабатывает параметр ?ref= из URL при загрузке страницы
 * 
 * ✅ Работает напрямую с window.location (не зависит от Vue Router)
 * ✅ Сохраняет токен в localStorage для последующего применения
 * 
 * Follows DRY, SOLID principles and Vue.js Style Guide
 */

import { consola } from 'consola';

const logger = consola.withTag('referral-token-plugin');

// Константы для localStorage ключей (должны совпадать с composable)
const STORAGE_KEY = 'pendingReferralToken';
const STORAGE_TIMESTAMP_KEY = 'pendingReferralTokenTimestamp';

/**
 * Извлечение токена из URL напрямую (без Vue Router)
 */
const getTokenFromUrl = (): string | null => {
  if (!process.client) return null;
  
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('ref');
    
    if (token && token.trim().length > 0) {
      return token.trim();
    }
  } catch (error) {
    logger.error('Ошибка извлечения токена из URL:', error);
  }
  
  return null;
};

/**
 * Сохранение токена в localStorage
 */
const saveTokenToStorage = (token: string): void => {
  if (!process.client) return;

  try {
    localStorage.setItem(STORAGE_KEY, token);
    localStorage.setItem(STORAGE_TIMESTAMP_KEY, Date.now().toString());
    logger.info('✅ Реферальный токен сохранен в localStorage:', token);
    
    // Проверяем что действительно сохранилось
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === token) {
      logger.debug('✅ Токен успешно сохранен, проверка пройдена');
    } else {
      logger.warn('⚠️ Токен не сохранился корректно');
    }
  } catch (error) {
    logger.error('Ошибка сохранения токена в localStorage:', error);
  }
};

/**
 * Очистка параметра ?ref= из URL
 */
const clearRefFromUrl = (): void => {
  if (!process.client) return;

  try {
    const url = new URL(window.location.href);
    url.searchParams.delete('ref');
    
    // Используем replaceState чтобы не добавлять в историю
    const newUrl = url.toString();
    window.history.replaceState({}, '', newUrl);
    logger.debug('Параметр ?ref= удален из URL');
  } catch (error) {
    logger.error('Ошибка очистки URL:', error);
  }
};

export default defineNuxtPlugin(() => {
  if (!process.client) return;

  // Обрабатываем токен сразу при загрузке плагина
  // Используем setTimeout чтобы убедиться что window.location доступен
  setTimeout(() => {
    try {
      const token = getTokenFromUrl();
      
      if (token) {
        // Сохраняем токен в localStorage
        saveTokenToStorage(token);
        
        // Очищаем URL от параметра
        clearRefFromUrl();
        
        logger.info('✅ Реферальный токен обработан и сохранен:', token);
      } else {
        logger.debug('Параметр ?ref= не найден в URL');
      }
    } catch (error) {
      logger.error('Ошибка обработки реферального токена:', error);
    }
  }, 0);
});

